import React from 'react';

export const DrillAndBlastGuide: React.FC = () => {
  return (
    <div className="guide-page map-3d-sidebar-content">
      <ul>
        <li>
          <span> Step 1 - </span>
          <p>
            Go to <b>Generate</b> tab and provide a title for your drill and
            blast request. This will help you find it later under the{' '}
            <b>History</b> tab.
          </p>
        </li>
        <li>
          <span> Step 2 - </span>
          <p>
            Define the <b>Area of Interest</b> by either drawing a polygon
            directly or selecting a vector layer from the workspace that
            contains exactly one polygon feature.
          </p>
        </li>
        <li>
          <span> Step 3 - </span>
          <p>
            If required, define the <b>Extent for the Blast</b> by either
            drawing a line or selecting a vector layer from the workspace that
            contains exactly one line feature.
          </p>
        </li>
        <li>
          <span> Step 4 - </span>
          <p>
            Enter the required blast parameters: <b>Spacing</b> (in meters),{' '}
            <b>Burden</b> (in meters), <b>Base Elevation</b> (in meters), and{' '}
            <b>Expected Number of Holes</b> (optional).
          </p>
        </li>
        <li>
          <span> Step 5 - </span>
          <p>Select <b>Explosive Type</b> and <b>Drill Pattern</b>.</p>
        </li>
        <li>
          <span> Step 6 - </span>
          <p>Click <b>Generate</b> once all required fields are submitted.</p>
        </li>
        <li>
          <span> Step 7 - </span>
          <p>Go to the <b>History</b> tab to see past submissions.</p>
        </li>
      </ul>
    </div>
  );
};
